import React from "react";
import { useNavigate } from "react-router-dom";
import { Crown, X, Check } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useSubscription } from "@/context/SubscriptionContext";

export default function PaywallModal() {
  const { paywall, setPaywall, sub } = useSubscription();
  const navigate = useNavigate();
  const open = !!paywall;

  const trialUsed = sub?.trial_status === "used" || sub?.trial_status === "active";

  const goPlans = () => {
    setPaywall(null);
    navigate("/app/subscribe");
  };

  const startTrial = () => {
    setPaywall(null);
    navigate("/app/subscribe?action=trial&plan=monthly");
  };

  const perks = [
    "Unlimited AI Coach conversations",
    "Unlimited Scripture breakdowns",
    "Legacy Tracker & Growth Plan",
    "Brotherhood accountability groups",
  ];

  return (
    <Dialog open={open} onOpenChange={(o) => !o && setPaywall(null)}>
      <DialogContent className="bg-[#0d0d0d] border-white/10 max-w-sm p-0 overflow-hidden" data-testid="paywall-modal">
        <DialogTitle className="sr-only">Upgrade to UnloadDaily Plus</DialogTitle>
        <DialogDescription className="sr-only">You've reached a free limit. Upgrade to UnloadDaily Plus for unlimited access, or start a 7-day free trial.</DialogDescription>
        <div className="bg-gradient-to-br from-primary/30 to-transparent p-6 relative">
          <button
            data-testid="paywall-close"
            onClick={() => setPaywall(null)}
            className="absolute top-3 right-3 text-muted-foreground hover:text-white"
          >
            <X size={18} />
          </button>
          <div className="h-12 w-12 rounded-xl bg-primary grid place-items-center glow-orange mb-3">
            <Crown size={24} className="text-white" />
          </div>
          <h2 className="heading text-3xl font-black tracking-tighter uppercase leading-none">
            Unlock <span className="text-primary">Plus</span>
          </h2>
          <p className="text-sm text-muted-foreground mt-2">
            {paywall?.message || "You've hit a free limit. Go Plus for unlimited training."}
          </p>
        </div>
        <div className="p-6 pt-2">
          <div className="space-y-2 mb-5">
            {perks.map((p) => (
              <div key={p} className="flex items-center gap-2 text-sm">
                <Check size={16} className="text-accent shrink-0" />
                <span>{p}</span>
              </div>
            ))}
          </div>
          {!trialUsed && (
            <button
              data-testid="paywall-start-trial-btn"
              onClick={startTrial}
              className="w-full bg-primary text-white font-bold tracking-widest uppercase rounded-lg hover:shadow-[0_0_20px_rgba(255,87,34,0.5)] transition-all py-3.5"
            >
              Start 7-Day Free Trial
            </button>
          )}
          <button
            data-testid="paywall-upgrade-btn"
            onClick={goPlans}
            className={`w-full font-bold tracking-widest uppercase rounded-lg transition-all py-3.5 ${
              trialUsed
                ? "bg-primary text-white hover:shadow-[0_0_20px_rgba(255,87,34,0.5)]"
                : "mt-3 border border-white/20 text-white hover:border-accent hover:text-accent"
            }`}
          >
            See Plans
          </button>
          <p className="text-xs text-center text-muted-foreground mt-3">
            {trialUsed ? "Cancel anytime" : "No charge today · Cancel anytime"}
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
